var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "facebook",
    d: "M22.675,0H1.325A1.325,1.325,0,0,0,0,1.325V22.676A1.325,1.325,0,0,0,1.325,24H12.82V14.706H9.692V11.084H12.82V8.413c0-3.1,1.893-4.788,4.659-4.788a25.657,25.657,0,0,1,2.8.143v3.24H18.356c-1.5,0-1.8.715-1.8,1.763v2.313h3.587l-.467,3.622h-3.12V24h6.116A1.324,1.324,0,0,0,24,22.675V1.325A1.325,1.325,0,0,0,22.675,0Z",
    fill: "#12233a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.efab47e318d97c477c7af8b4bb0414e2.svg";
export { ForwardRef as ReactComponent };